/**
 *
 * InputStyled
 *
 */
import { forwardRef, memo, Ref, useState } from 'react';

import { ReactComponent as PencilIcon } from 'assets/icons/pencil.svg';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as EyeCloseIcon } from 'assets/icons/eye-close.svg';

import { Wrapper, InputWrapper, LabelWrapper, PencilIconWrapper, EyeIconWrapper, DescriptionWrapper } from './styles';

interface Props {
  variant: string;
  type?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: any) => void;
  placeholder?: string;
  label?: string;
  labelColor?: string;
  labelWeight?: number;
  description?: string;
  showPencil?: boolean;
  mr?: number | number[];
  ml?: number | number[];
  mt?: number | number[];
  mb?: number | number[];
  height?: string | number;
  name?: string;
  disabled?: boolean;
  error?: boolean | any;
  passwordConfirmed?: boolean | any;
  width?: string;
  [x: string]: any;
}

const InputRef = forwardRef(
  (
    {
      variant,
      width,
      type,
      value,
      onChange,
      onKeyDown,
      placeholder,
      label,
      labelColor = 'blacks.1',
      labelWeight = 2,
      showPencil,
      description,
      height,
      mr,
      ml,
      mt,
      mb,
      name,
      disabled,
      error,
      passwordConfirmed,
      ...props
    }: Props,
    ref: Ref<any>,
  ) => {
    /**
     * State
     */
    const [inputType, setInputType] = useState<string>(type ? type : 'text');

    /**
     * Functions
     */
    const renderLabel = () =>
      label && (
        <LabelWrapper width={width} color={labelColor} fontSize={1} fontWeight={labelWeight} mb={description ? 2 : 3}>
          {label}
        </LabelWrapper>
      );

    const renderDescription = () => description && <DescriptionWrapper>{description}</DescriptionWrapper>;

    /**
     * Return
     */
    return (
      <Wrapper
        display="flex"
        width={width ? width : '100%'}
        flexDirection="column"
        position="relative"
        mr={mr}
        ml={ml}
        mt={mt}
        mb={mb}
      >
        {renderLabel()}
        {renderDescription()}
        <InputWrapper
          {...props}
          type={inputType}
          value={value}
          variant={variant}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          error={error}
          ref={ref}
          passwordConfirmed={passwordConfirmed}
          height={height}
          width={width}
          name={name}
          disabled={disabled}
        />
        {showPencil && (
          <PencilIconWrapper display="flex" position="absolute" bottom="0" right="0" color="greens.2">
            <PencilIcon />
          </PencilIconWrapper>
        )}
        {type === 'password' && (
          <EyeIconWrapper
            display="flex"
            position="absolute"
            bottom="-12px"
            right="10px"
            color="greens.2"
            height={height}
            onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}
          >
            {inputType === 'password' ? <EyeIcon /> : <EyeCloseIcon />}
          </EyeIconWrapper>
        )}
      </Wrapper>
    );
  },
);

export const InputStyled = memo(InputRef);
